import { createTheme } from "@mui/material/styles";

const getModalContainer = (): HTMLElement | null => {
  if (typeof document === "undefined") return null;
  return (
    (document.fullscreenElement as HTMLElement) ||
    ((document as any).webkitFullscreenElement as HTMLElement) ||
    ((document as any).mozFullScreenElement as HTMLElement) ||
    ((document as any).msFullscreenElement as HTMLElement) ||
    document.body
  );
};

const theme = createTheme({
  palette: {
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    text: {
      primary: "#1e293b",
      secondary: "#64748b",
    },
    primary: {
      main: "#2563eb",
      light: "#dbeafe",
      dark: "#1d4ed8",
    },
  },
  zIndex: {
    modal: 1500,
    snackbar: 1600,
    tooltip: 1700,
  },
  components: {
    MuiModal: {
      defaultProps: {
        container: getModalContainer,
      },
    },
    MuiDialog: {
      defaultProps: {
        container: getModalContainer,
      },
    },
    MuiPopover: {
      defaultProps: {
        container: getModalContainer,
      },
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
});

export default theme;
